import MailsTemplate from "./MailsTemplate";

export default MailsTemplate;